export default "__VITE_ASSET__BdNsnzey__"